// @flow

import * as React from 'react';
import { downloadTemplate, uploadLineups } from 'app/api/challenges';
import CSVPage from './CSVPage';

type Props = {
  onRedirect: () => void
};

function UploadLineup({ onRedirect }: Props) {
  return (
    <CSVPage downloadFunc={downloadTemplate} uploadFunc={uploadLineups} onRedirect={onRedirect} />
  );
}

export default UploadLineup;
